import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useNavigate, useLocation } from 'react-router-dom';
import { Users, GraduationCap, AlertCircle } from 'lucide-react';

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const error = params.get('error');

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 via-white to-blue-50 px-4">
      <Card className="w-full max-w-md p-8 shadow-xl border border-slate-200">
        <div className="flex flex-col items-center text-center mb-6">
          <div className="w-20 h-20 rounded-full bg-gradient-to-br from-slate-900 to-slate-700 flex items-center justify-center mb-4 shadow-lg">
            <svg viewBox="0 0 24 24" className="w-11 h-11 text-yellow-400 fill-current">
              <path d="M12 2L4 6v6c0 5.5 3.8 10.7 8 12 4.2-1.3 8-6.5 8-12V6l-8-4zm0 2.3l6 3v4.7c0 4.4-2.9 8.6-6 9.9-3.1-1.3-6-5.5-6-9.9V7.3l6-3z" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-slate-900">Eagle Academy WPK8</h1>
          <p className="text-slate-500 text-sm mt-1">Choose how you&apos;d like to sign in</p>
        </div>

        {error && (
          <div className="mb-4 p-3 rounded-lg bg-red-50 border border-red-200 flex items-start gap-2">
            <AlertCircle className="w-4 h-4 text-red-600 flex-shrink-0 mt-0.5" />
            <p className="text-sm text-red-800">{decodeURIComponent(error)}</p>
          </div>
        )}

        <div className="space-y-3">
          <button
            onClick={() => navigate('/staff-login')}
            className="w-full p-5 rounded-xl border-2 border-slate-200 hover:border-blue-400 hover:bg-blue-50 transition-all duration-200 flex items-center gap-4 text-left group"
          >
            <div className="w-12 h-12 rounded-lg bg-blue-100 group-hover:bg-blue-200 flex items-center justify-center flex-shrink-0">
              <Users className="w-6 h-6 text-blue-700" />
            </div>
            <div className="flex-1">
              <p className="font-semibold text-slate-900">Staff Login</p>
              <p className="text-xs text-slate-500 mt-0.5">Sign in with your @iltexas.org Google account</p>
            </div>
          </button>

          <button
            onClick={() => navigate('/student-login')}
            className="w-full p-5 rounded-xl border-2 border-slate-200 hover:border-green-400 hover:bg-green-50 transition-all duration-200 flex items-center gap-4 text-left group"
          >
            <div className="w-12 h-12 rounded-lg bg-green-100 group-hover:bg-green-200 flex items-center justify-center flex-shrink-0">
              <GraduationCap className="w-6 h-6 text-green-700" />
            </div>
            <div className="flex-1">
              <p className="font-semibold text-slate-900">Student Login</p>
              <p className="text-xs text-slate-500 mt-0.5">Sign in with your student ID and password</p>
            </div>
          </button>
        </div>

        <p className="text-xs text-slate-400 text-center mt-6">
          Need help? Contact <a href="mailto:csteele@iltexas.org" className="underline hover:text-slate-600">csteele@iltexas.org</a>
        </p>
      </Card>
    </div>
  );
}
